import { forwardRef } from "react";
import { ark, HTMLArkProps } from "@ark-ui/react";
import { mergeProps } from "@zag-js/react";

import styles from "./label.module.css";

const Label = forwardRef<HTMLDivElement, HTMLArkProps<"div">>((props, ref) => {
  const mergedProps = mergeProps(
    {
      className: styles.label,
    },
    props,
  );
  return <ark.span {...mergedProps} ref={ref} />;
});

Label.displayName = "Label";

export default Label;

export function Badge(props: HTMLArkProps<"div">) {
  const mergedProps = mergeProps({ className: styles.badge }, props);
  return <Label {...mergedProps} />;
}
